module.exports = __webpack_public_path__ + "static/media/custom-ex-14.fe917646.jpg";